export const PROMO_CODE_QUERY_KEY = 'promoCode'
export const BUSINESS_PROMO_CODE_QUERY_KEY = 'businessPromoCode'
